import { Component } from "react";
import {
  set_datapage,
  SetLanguage,
  getLanguage,
} from "@ora/recursos/src/redux/actions/DataPageAction";
import { connect } from "react-redux";
import { createHChartTreeMaps } from "layouts/mainsection/components/CHighchartToolsTraffic";
import Highcharts from 'highcharts';


class OETInvolucradasIncidenteTreemap extends Component {
  componentDidMount() {
    setTimeout(() => {
      this.setState({
        init: true,
        container: <div id={ this.id }></div>
      })
      // console.log(this.state.container)
    }, 500)

  }

  componentDidUpdate(){
    
  }
  render() {
    //[{year: 2002, value: 10.5}]

    return this.props.data.series.length > 0 ? (
      <>
        {createHChartTreeMaps("chartMDOETInvolucradasIncidenteTreemap", {
          title: {
            text: this.props.title,
          },
          
          series: [{
                    legendType: 'point',
                    
                    showInLegend: true,
                    type: "treemap",
                    layoutAlgorithm: 'squarified',
                    allowDrillToNode: true,
                    alternateStartingDirection: true,
                    levels: [{
                        level: 1,
                        layoutAlgorithm: 'sliceAndDice',
                        dataLabels: {
                            enabled: true,
                            align: 'left',
                            verticalAlign: 'top',
                            style: {
                                fontSize: '12px',
                                fontWeight: 'bold',
                                fontStyle:'italic'
                            }
                        }
                    }],
                    data: this.props.data.series
                }],
        })}
        <div style={{ fontSize: "0.9em" }}>
          <div className="has-text-centered" style={{ fontSize: "0.9em" }}>
            <p
              className="px-6"
              style={{
                color: "#000",
                fontSize: "1.1em",

                fill: "#000",
              }}
            >
              <i>{this.props.description}</i>
            </p>
          </div>
        </div>
      </>
    ) : null;
  }
}

export default connect(getLanguage, { set_datapage, SetLanguage })(
  OETInvolucradasIncidenteTreemap
);
